import t from "@/lang/lang";
import { GSMServiceKind } from "@/services/backend/services/types/kinds";
import { EditorVariable } from "@/shared/components/editor/editor-variables";

/**
 * serviceKindTextVariables returns the variables only the texts of the
 * service kind's offers and contracts take. Mirrors the `TextVariables`
 * of the PDF rulesets,
 * backend/core/omni/adapters/driving/gotenbergpdf/servicekindrules/.
 */
export function serviceKindTextVariables(
  serviceKind: string,
): EditorVariable[] {
  switch (serviceKind) {
    case GSMServiceKind.WRH:
      return [
        {
          name: "$wrh_products",
          label: t("WRH Produkte"),
          description: t("Liste der Produkte"),
        },
        {
          name: "$wrh_products_count_placeholders",
          label: t("WRH Produkte mit Mengenfeld"),
          description: t("Liste der Produkte mit Feld für die Menge und Preis"),
        },
      ];
    default:
      return [];
  }
}
